import React, { useState, useEffect } from 'react'; 
import { getAuth, onAuthStateChanged } from 'firebase/auth';

// --- Image Imports ---
import appLogo from '../images/Fruit_of_War_Logo.png';
import coverImage from '../images/cans_mockup.png'; // Hero image
import discordImage from '../images/discord.png';
import whiteSplash from '../images/White_Splash.png';

// Fruits - Character Images & Backgrounds
import appleBackground from '../images/apple_no_background.png';
import appleImage from '../images/apple.png';
import lemonBackground from '../images/lemon_no_background.png';
import lemonImage from '../images/Just Lawrence.png';
import grapeBackground from '../images/grape_no_background.png';
import grapeImage from '../images/Giselle.png';
import mangoBackground from '../images/mango_no_background.png';
import mangoImage from '../images/Marques.png';
import tangerineBackground from '../images/tangerine_no_background.png';
import tangerineImage from '../images/Thomas.png';

// Stamp Logos
import redLogo from '../images/Red Logo.png';
import purpleLogo from '../images/Purple Logo.png';
import yellowLogo from '../images/Yellow Logo.png';
import goldLogo from '../images/Gold Logo.png'; // Assuming gold for Mango
import orangeLogo from '../images/Orange Logo.png';


// Placeholders
const placeholderBg = 'https://th.bing.com/th/id/R.bf70155a4dfd37a4213763f641ce173b?rik=mVrK%2fkxRL5A6Zw&riu=http%3a%2f%2fattemptnwin.com%2fwp-content%2fuploads%2f2014%2f10%2ffruits2.jpg&ehk=00jfR2bVaUX1cydZBvNLOUMchFNyHd%2f4jztW%2fRmBEfM%3d&risl=&pid=ImgRaw&r=0';
const placeholderNews = 'https://img.huffingtonpost.com/asset/55c8b3cc170000b700567097.jpeg?cache=2vhgqpbkqd&ops=1910_1000';
const placeholderVideo = 'https://th.bing.com/th/id/R.bf70155a4dfd37a4213763f641ce173b?rik=mVrK%2fkxRL5A6Zw&riu=http%3a%2f%2fattemptnwin.com%2fwp-content%2fuploads%2f2014%2f10%2ffruits2.jpg&ehk=00jfR2bVaUX1cydZBvNLOUMchFNyHd%2f4jztW%2fRmBEfM%3d&risl=&pid=ImgRaw&r=0';
const placeholderHero = coverImage;
const placeholderLogo = appLogo;

// --- Initial State Definition ---
export const initialState = {
    // appURL: 'http://localhost:3000', // Dev
    appURL: 'https://fruitofwar.com', // Prod

    appLogo: placeholderLogo,
    appName: 'Fruit of War',

    // --- Hero Section ---
    coverTitle: 'Choose your vibe!',
    coverText1: "Welcome to Fruitopia! There are 5 groups of Fruitopians battling to be victorious. Each tribe has their own motivations, exemplary warriors, and unique weapons.",
    coverText2: "You will have a chance to assist your favorite tribe! Every “Fruit of War” drink will be converted into resources to help support your favorite faction by scanning the label’s QR code. Every scan has a direct impact on the campaign's direction and tribe success during that battle season.",
    coverText3: "You have your mission, scan the codes and use the resources. You decide how the war evolves, how you beat your enemies, and help your allies. You choose who is the best “Fruit of War” and YOU. CHOOSE. YOUR. VIBE.",
    coverImage: placeholderHero,
    whiteSplash: whiteSplash,

    // --- Mailing List Section ---
    endorsementTitle: `Make a difference in the Fruitopia universe!`,
    endorsementText: `Join our mailing list to hear more about the Fruitopia world and be the first to try our newest flavors`,

    // --- Character Data ---
    characters: [
        {
            id: 1,
            name: `Col. Adam Appleton`,
            description: `Adam has always lived his life in the fast lane...`,
            fullDescription: `Adam has always lived his life in the fast lane. His first car was already a high octane beast, but when he modded it the car went from beast to speed demon. The only natural next step was the fighter jets. He was a master pilot, the likes of which the sky had never seen before. Then when the scientists developed a new weapon to end the war, but the pilot who used it would have to be gone in an instant. Adam was the only choice and as he dropped the Big Apple from his plane he proved that the speed was within him and that he would use it in the War for Fruitopia.`,
            image: appleImage,
            background: appleBackground,
            stampLogo: redLogo,
        },
        {
            id: 2,
            name: `CDR. Lawrence Lemollo`,
            description: `Lawrence was the eldest child in a family of farmers...`,
            fullDescription: `Lawrence was the eldest child in a family of farmers. His family, just like the rest of his village, grew lush groves on their fields from dawn to dusk. Then the Citrussian government drafted him for the war. While Lawrence rose through the ranks fighting with his trusty LMG, the farmers eventually revolted. When Lawrence returned home, his village and family were wiped out. On that day he swore vengeance against the Citrussians and leads the Sour Guard in the War for Fruitopia.`,
            image: lemonImage,
            background: lemonBackground,
            stampLogo: yellowLogo,
        },
        {
            id: 3,
            name: `Maj. Giselle Granea`,
            description: `Born an orphan, Giselle never had an easy childhood...`,
            fullDescription: `Born an orphan, Giselle never had an easy childhood. She moved from family to family all throughout her youth, changing schools, hardly making friends, and never seeming to fit in. Thankfully though, she had her brother through it all. [Insert name] was only just a few years older, but looked after Giselle in every way he could, keeping her from any types of harm, and trying to give her a better future. When the war broke out, a rebel fruit faction took him hostage, and brutally juiced him to set an example for the public. From that day onward, Giselle lost a piece of her soul, and what was once a shy and awkward little girl was the most feared soldier on the battlefield.`,
            image: grapeImage,
            background: grapeBackground,
            stampLogo: purpleLogo,
        },
        {
            id: 4,
            name: `Marques Mangrol`,
            description: `A strong body with a soft soul, Marques grew up during the peaceful times...`,
            fullDescription: `A strong body with a soft soul, Marques grew up during the peaceful times of Frangomia. With his father as major during the first war of Frutopia, Marcus is no stranger to combat. Growing up, he was trained like a soldier, as his father made sure he was ready for what was coming. Yet his mother always made sure to remind him of the joys of life and the goodness of the world. She made sure that even while he was a strong fighter, he stayed a kind person. With his spare time, he loved playing with his pet Rabbit, Jacque, who he cherished deeply. When the second war broke out his mother was one of the early casualties. On her deathbed she made him promise to always be a good person. So he made it his mission to protect his country and to help end the War for Fruitopia.`,
            image: mangoImage,
            background: mangoBackground,
            stampLogo: goldLogo,
        },
        {
            id: 5,
            name: `Pvt. Thomas Tangernelle`,
            description: `Some would say Thomas was naive, he would describe himself as a true believer...`,
            fullDescription: `Some would say Thomas was naive, he would describe himself as a true believer. He loved his country, he truly did. Citrussia had given him his entire life and he was grateful. So when the war started, he was more than willing to serve his great nation. He excelled at tank combat and was known throughout as the best gunner and driver. Soon his unit was tasked with quelling the Lemon rebellions and that is when his belief was challenged. He couldn’t let the Sour Guard hurt any more innocents but he also hated how the army was treating the Lemon civilians. He realized that he had to change the system he lived in for the better and the only way to do so is to stop the rebels. His tank is armed and his mission is set; Thomas will stop the Sour Guard and lead his country out of the War for Fruitopia.`,
            image: tangerineImage,
            background: tangerineBackground,
            stampLogo: orangeLogo,
        },
    ],

    // --- News Gallery Section ---
    newsItems: [
         {
           id: 1,
           title: "Released Adam Appleton",
           excerpt: "Our team has successfully deployed Adam. Read more about the first mission.",
           date: "2 days ago",
           image: placeholderNews,
           type: "article",
           link: "#"
         },
         {
           id: 2,
           title: "New Citrussia Supply Lines Established",
           excerpt: "Logistics update: Supplies are now flowing more reliably to the Tangerine front lines.",
           date: "1 week ago",
           image: placeholderNews,
           type: "article",
           link: "#"
         },
         {
           id: 3,
           title: "Sour Guard Makes Tactical Retreat",
           excerpt: "Reports indicate CDR. Lemollo's forces have pulled back to regroup after heavy fighting.",
           date: "2 weeks ago",
           image: placeholderNews,
           type: "article",
           link: "#"
         },
         {
            id: 7, // Added placeholder
            title: "Frangomian Tech Advances",
            excerpt: "Marques Mangrol benefits from new shield technology developed in Frangomia.",
            date: "3 weeks ago",
            image: placeholderNews,
            type: "article",
            link: "#"
          },
         {
           id: 4,
           title: "First Battle Highlights",
           thumbnail: placeholderVideo,
           duration: "4:32",
           type: "video",
           videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ" // Placeholder link
         },
         {
           id: 5,
           title: "Maj. Giselle Granea INTERVIEW",
           thumbnail: placeholderVideo,
           duration: "7:15",
           type: "video",
           videoUrl: "#"
         },
         {
           id: 6,
           title: "Behind the Scenes: Making Fruitopia",
           thumbnail: placeholderVideo,
           duration: "12:48",
           type: "video",
           videoUrl: "#"
         },
           {
             id: 8, // Added placeholder
             title: "Combat Training: Col. Appleton",
             thumbnail: placeholderVideo,
             duration: "5:50",
             type: "video",
             videoUrl: "#"
            },
    ],

    // --- Contact Section ---
    contactEmail: 'contact@fruitofwar.com',
    contactPhone: '+1 (123) 456-7890',
    contactAddress: '1234 Apple Avenue, New York',
    socialLinks: {
        facebook: '#',
        twitter: '#',
        instagram: '#',
        youtube: '#'
    },

    // --- Footer/Misc ---
    discordImage: discordImage,
    discordLink: '#', // Added placeholder link

    // --- Auth State ---
    currentUser: null,
    loadingAuthState: true,
};

// --- Create Context ---
const initialContext = {
    state: initialState,
    // dispatch: () => null, // Use setState instead if using useState
    setState: () => null,
};
export const Context = React.createContext(initialContext);

// --- Create Context Provider Component ---
export const ContextProvider = ({ children }) => {
    const [state, setState] = useState(initialState);

    // Effect to listen for Firebase Auth state changes
    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setState(prevState => ({
                ...prevState,
                currentUser: user,
                loadingAuthState: false,
            }));
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []); // Empty dependency array means this runs once on mount

    return (
        <Context.Provider value={{ state, setState }}>
            {children}
        </Context.Provider>
    );
};